import { render, staticRenderFns } from "./AlUla.vue?vue&type=template&id=616f1f18&"
import script from "./AlUla.vue?vue&type=script&lang=js&"
export * from "./AlUla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports